import { emit, events } from 'elc-service-bus';

export class AuthFailedUseCase {
    private error: string;
    constructor(error: string) {
        this.error = error;
    }
    public execute = () => {
        emit(events.AUTH_FAILED, this.error);
    };
}
